export interface CloudAllData {
  userData: UserData;
  heroesData: HeroesData;
}

export interface UserData {
  deviceID: string;
  questId: number;
  playTime: number;
  ruby: number;
  gold: number;
  firstTimePlay: boolean;
  premiumUser: boolean;
  boughtAltPass: boolean;
  boughtStarterPack: boolean;
  boughtOffer1: boolean;
  boughtOffer2: boolean;
  boughtOffer3: boolean;
  boughtOffer4: boolean;
  boughtOffer5: boolean;
  characterBanner: Record<string, CharacterBanner>;
  eventpass_ads: unknown;
  eventExclusiveItems: Record<string, unknown>;
  welkinStatus: WelkinStatus;
  welkinMaterialStatus: WelkinStatus;
  petData: unknown;
  randomCraftingSeeds: Record<string, number>;
  randomAppraiseSeeds: Record<string, Record<string, number>>;
  randomUpgradeSeed: number;
  randomGachaSeed: number;
  randomRuneSeed: number;
  randomImprintSeed: number;
  randomPetSeed: number;
  lastCheckpoint: string;
  activeFeastBuff: string;
  feastDuration: number;
  feastActivationTime: string;
  acquiredAbyssalTear: number;
  lastAbyssalTear: string;
  abyssalClearedAreas: unknown[];
  claimedCoupons: ClaimedCoupon[];
  [key: string]: unknown;
}

export interface ClaimedCoupon {
  couponId: string;
  claimedAt: string;
}

export interface CharacterBanner {
  bannerId: string;
  bought: unknown[];
}

export interface WelkinStatus {
  lastClaim: string;
  validUntil: string;
}

export interface HeroesData {
  heroes: Hero[];
  [key: string]: unknown;
}

export interface Hero {
  HERO: number;
  LEVEL: number;
  EXP: number;
  STR: number;
  INT: number;
  DEX: number;
  AGI: number;
  VIT: number;
  ATK: number;
  HP: number;
  skillSlot: number[];
  skillLevels: number[];
  skillExp: number[];
  masteryLvl: number[];
  equipment: Equipment[];
  [key: string]: unknown;
}

export interface Equipment {
  id: string | null;
  enhancementLevel: number;
  currentEXP: number;
  currentRarity: number;
  randomStat: RandomStat | null;
  fixedStats: FixedStat[];
  socketStats: SocketStat[];
  quantity: number;
  seed: number;
  [key: string]: unknown;
}

export interface RandomStat {
  stats: number;
  value: number;
}

export interface FixedStat {
  stats: number;
  value: number;
}

export interface SocketStat {
  socketID: string;
  currentLevel: number;
  currentEXP: number;
}

export interface SusData {
  rdt: number;
  totalOut: number;
  totalIn: number;
  pre: boolean;
  lists: string[];
  phData: unknown[];
  outcome: unknown[];
  income: unknown[];
  hero: SusHero[];
  valueBeforeNewestUpdate: Record<string, number>;
  historyAdded: Record<string, number>;
  historyRemoved: Record<string, number>;
  Reason: string[];
  [key: string]: unknown;
}

export interface SusHero {
  HERO?: number;
  LEVEL: number;
  STR: number;
  INT: number;
  DEX: number;
  AGI: number;
  VIT: number;
  ATK: number;
  HP: number;
  [key: string]: unknown;
}

export interface SideQuest {
  questIndex: number;
  objectiveProgresses: ObjectiveProgress[];
  isCompleted: boolean;
  [key: string]: unknown;
}

export interface ObjectiveProgress {
  currentProgress: number;
  maxProgress: number;
  done: boolean;
}

export interface MysticMine {
  enterCount: number;
  lastTrade: string;
  lastMine: string;
  collectedItems: Record<string, number>;
}

export interface MailReward {
  type?: string;
  amount: number;
  itemID?: string;
  heroID?: string;
  rewardType?: number;
  hero?: number;
  developerBuffID?: string;
  recipe?: number;
  iapProductId?: string;
  [key: string]: unknown;
}

// Numeric codes match the game's RewardType enum (AttendanceReward.cs).
export const REWARD_TYPE_NAMES: Record<number, string> = {
  0: "Item",
  1: "Gold",
  2: "Ruby",
  3: "Premium Pass",
  4: "Hero",
  5: "Daily Ruby Pack",
  6: "Raven Pass",
  7: "Maid/Butler Pass",
  8: "Academia Pass",
  9: "Daily Material Pack",
  10: "Developer Buff",
  11: "Fishing Net",
  12: "Unlimited Fishing",
  13: "Rent Helper",
  14: "No Boss",
  15: "Free Rift",
  16: "Recipe",
  100: "IAP",
};

// Hero enum from HeroReference.cs (None = 0 excluded).
export const HERO_NAMES: Record<number, string> = {
  1: "Claris",
  2: "Chase",
  3: "Amy",
  4: "Alaster",
  5: "Edna",
  6: "Louisa",
  7: "Elze",
  8: "Zerav",
};

export function mailRewardTypeLabel(r: MailReward): string {
  if (r.type) return r.type;
  if (typeof r.rewardType === "number") {
    return REWARD_TYPE_NAMES[r.rewardType] ?? `Type ${r.rewardType}`;
  }
  return "—";
}
